import { render, staticRenderFns } from "./TestPriceAlert.vue?vue&type=template&id=c6a1bc52"
import script from "./TestPriceAlert.vue?vue&type=script&lang=js"
export * from "./TestPriceAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports